const numberFormat = new Intl.NumberFormat("ko-KR", {
  maximumFractionDigits: 6,
});

const moneyFormat = new Intl.NumberFormat("ko-KR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 6,
});

export function formatNumber(value: string | number | undefined, fallback = "-") {
  if (value === undefined || value === null || value === "") return fallback;
  const number = Number(value);
  return Number.isFinite(number) ? numberFormat.format(number) : fallback;
}

export function formatUsdc(value: string | number | undefined, fallback = "-") {
  if (value === undefined || value === null || value === "") return fallback;
  const number = Number(value);
  return Number.isFinite(number) ? `${moneyFormat.format(number)} USDC` : fallback;
}

export function formatDollar(value: string | number | undefined, fallback = "-") {
  if (value === undefined || value === null || value === "") return fallback;
  const number = Number(value);
  return Number.isFinite(number) ? `$${moneyFormat.format(number)}` : fallback;
}

export function formatSignedUsdc(value: string | number | undefined) {
  if (value === undefined || value === null || value === "") return "-";
  const number = Number(value);
  if (!Number.isFinite(number)) return "-";
  const sign = number > 0 ? "+" : "";
  return `${sign}${moneyFormat.format(number)} USDC`;
}

export function formatTime(value?: string) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat("ko-KR", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  }).format(date);
}

export function formatKstTime(value?: string, fallback = "시간 확인 중") {
  if (!value) return fallback;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return fallback;
  return `${new Intl.DateTimeFormat("ko-KR", {
    timeZone: "Asia/Seoul",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).format(date)} KST`;
}

export function visibleStatus(status?: string) {
  switch (status) {
    case "filled":
      return "체결";
    case "simulated":
      return "연습 기록";
    case "exchange_error":
    case "error":
      return "확인 필요";
    case "active":
      return "활동 중";
    case "terminated":
      return "종료";
    default:
      return status || "-";
  }
}

export function visibleSide(side?: string) {
  if (side === "buy") return "매수";
  if (side === "sell") return "매도";
  return side || "-";
}

export function compactAddress(address?: string) {
  if (!address) return "-";
  return address;
}
